import request from './request';

/** Let axios set multipart boundary (same as blog service). */
const formDataConfig = { headers: { 'Content-Type': undefined } };

const storiesService = {
  getAll: (params) => request.get('dashboard/admin/stories', { params }),
  getPaginate: (params) =>
    request.get('dashboard/admin/stories/paginate', { params }),
  getById: (id) => request.get(`dashboard/admin/stories/${id}`),
  create: (body) => request.post('dashboard/admin/stories', body),
  upload: (formData) =>
    request.post('dashboard/admin/stories/upload', formData, formDataConfig),
  /**
   * Build a story group from a product's variants: one slide per variant,
   * using that variant's own photo and linked to it.
   * Body: product_id, stock_ids (in play order), duration, active.
   */
  createFromProduct: (body) =>
    request.post('dashboard/admin/stories/from-product', body),
  /**
   * JSON body: active, duration, product_id (clear link with null), and
   * `slides` — one row per picture, `{url, product_id, stock_id}`, which
   * replaces both fileUrls and the story-level link.
   */
  update: (id, body) => request.put(`dashboard/admin/stories/${id}`, body),
  setActive: (id) => request.post(`dashboard/admin/stories/${id}/active`),
  deleteById: (id) => request.delete(`dashboard/admin/stories/${id}`),
  delete: ({ ids }) =>
    request.delete('dashboard/admin/stories/delete', { data: { ids } }),
  dropAll: () => request.get('dashboard/admin/stories/drop/all'),
  /** Shop-wide engagement: totals, the story leaderboard, the emoji mix, recent replies. */
  analyticsOverview: (params) =>
    request.get('dashboard/admin/stories/analytics/overview', { params }),
  /** One story, down to who replied and when. */
  analyticsForStory: (id, params) =>
    request.get(`dashboard/admin/stories/${id}/analytics`, { params }),
};

export default storiesService;
